import React, { useState, useEffect, useCallback } from "react";
import "../../styles/desktop/main.css";

import CampoImagem     from "../CampoImagem/campoimagem";
import Menu            from "../menu/menu";
import TextMain        from "../Texto Principal/textoMain";
import Agendamentos    from "../Agendamento/agendamento";
import Loader          from "../loader/loader";
import Exaustor        from "../Exaustores/exaustores";
import Eventos         from "../events/eventos";
import background      from "../../assets/img/background.png";
import pagina1 from "../../assets/img/Pagina01.jpg";
import pagina2 from "../../assets/img/Pagina02.jpg";

import Grupo01 from "../Campo Luzes/Terreo";
import Grupo02 from "../Campo Luzes/Intermediario";

import AlarmeModal     from "../Alarme/AlarmeModal";
import Subsolo         from "../Campo Luzes/Subsolos/subsolos";

import ChatBot         from "../Plus/ChatBot/chatbot";
import PLUS            from "../Plus/plus";
import Dispositivos    from "../Plus/Dispositivos/dispositivo";
import Gestao          from "../Gestao/gestao";
import Notificacao     from "../Notificacao/notificacao";

// ===================  APIs  ===============================
import getRegistrosEventos from "../../API/events/getRegistrosEventos";
import getAllChamados      from "../../API/server/getChamados";
import processEventosEChamados from "../../API/utils/processEventos";
import { getAlarmes } from "../../API/basic/getAlarmes";
// ==========================================================

/** Utilitário: resolve ou timeout em `ms` */
const fetchComTimeout = (ms, prom) =>
  Promise.race([prom, new Promise((_, rej) => setTimeout(() => rej(new Error("timeout")), ms))]);

const TIMEOUT_MS = 3500;
const POLL_MS    = 5000;

const Main = () => {
  // ---------- páginas / UI ----------
  const [paginaAtual, setPaginaAtual] = useState("Térreo");
  const [filtro, setFiltro]           = useState("Todos");
  const [loadingImage, setLoadingImg] = useState(false);
  const [imagemCentral, setImagemCentral] = useState(pagina1);

  // ---------- eventos / chamados ----------
  const [eventos,  setEventos]  = useState([]);
  const [chamados, setChamados] = useState([]);
  const [loadingEventos, setLoadingEventos] = useState(true);

  // ---------- alarmes (CAIXA D’ÁGUA + BOMBAS) ----------
  const [caixas,  setCaixas]  = useState([]);
  const [bombas,  setBombas]  = useState([]);
  const [alarmStatus, setAlarmStatus] = useState("ok"); // loading | ok | error

  // =====================================================
  // 1) ---- BUSCA DE EVENTOS + CHAMADOS -----------------
  // =====================================================
  const dadosSaoDiferentes = (a, b) => JSON.stringify(a) !== JSON.stringify(b);

  const carregarEventos = useCallback(async (forceReload = false) => {
    try {
      if (forceReload) setLoadingEventos(true);

      const [ev, ch] = await Promise.all([getRegistrosEventos(), getAllChamados()]);

      if (dadosSaoDiferentes(ch, chamados)) setChamados(ch);

      const processados = processEventosEChamados(ev, ch).sort((x, y) => {
        const [d1, m1, a1] = x.data.split("/");
        const [d2, m2, a2] = y.data.split("/");
        return new Date(`${a2}-${m2}-${d2}`) - new Date(`${a1}-${m1}-${d1}`);
      });

      if (dadosSaoDiferentes(processados, eventos)) setEventos(processados);
    } catch (err) {
      console.error("Erro ao buscar eventos:", err);
    } finally {
      setLoadingEventos(false);
    }
  }, [eventos, chamados]);

  // =====================================================
  // 2) ---- BUSCA DE ALARMES -----------------------------
  // =====================================================
  const carregarAlarmes = useCallback(async () => {
    try {
      if (alarmStatus === "loading") setAlarmStatus("loading");
      const data = await fetchComTimeout(TIMEOUT_MS, getAlarmes());
      setCaixas(data[0] || []);
      setBombas(data[1] || []);
      setAlarmStatus("ok");
    } catch (err) {
      console.error("Falha ao buscar alarmes:", err);
      setAlarmStatus("error");
    }
  }, [alarmStatus]);

  // -----------------------------------------------------
  // ***** CICLO DE VIDA *********************************
  // -----------------------------------------------------
  useEffect(() => {
    // Eventos / chamados
    carregarEventos(true);
    const idEventos = setInterval(() => carregarEventos(false), 5000);

    // Alarmes
    carregarAlarmes();
    const idAlarmes = setInterval(carregarAlarmes, POLL_MS);

    return () => {
      clearInterval(idEventos);
      clearInterval(idAlarmes);
    };
  }, []);

  // =====================================================
  // 3) ---- HANDLERS DE UI ------------------------------
  // =====================================================
  const groupComponents = { [pagina1]: <Grupo01 />, [pagina2]: <Grupo02 /> };

  const trocarPagina = useCallback((pagina) => {
    if (["Agendamentos","Alarme","Exaustor","Gestao","Chatbot","PLUS"].includes(pagina)) {
      setImagemCentral("");
    }
    if (pagina === "history") setFiltro("Todos");
    setPaginaAtual(pagina);
  }, []);

  const renderGroup = () => groupComponents[imagemCentral] || groupComponents[paginaAtual] || null;

  const loaderImage = useCallback(() => {
    setPaginaAtual(pagina1);
    setLoadingImg(true);
    setTimeout(() => setLoadingImg(false), 1000);
  }, []);

  const trocarImagem = useCallback((img) => {
    if (imagemCentral !== img) {
      loaderImage();
      setImagemCentral(img);
    }
  }, [imagemCentral, loaderImage]);

  // =====================================================
  // 4) ---- RENDER --------------------------------------
  // =====================================================
  return (
    <div id="divMain">
      {loadingEventos && <Loader />}

      {/* --- MENU --- */}
      <Menu
        trocarPagina={trocarPagina}
        trocarImagem={trocarImagem}
        paginaAtual={paginaAtual}
        paginas={[pagina1, pagina2]}
        /* ▼ novos props, use-os como quiser no Menu */
        alarmStatus={alarmStatus}
        caixasAlarmes={caixas}
        bombasAlarmes={bombas}
      />

      {/* --- CONTEÚDO --- */}
      <div id="content" style={{ backgroundImage: `url(${background})` }}>
        <TextMain />

        {paginaAtual === "Gestao" ? (
          <Gestao />
        ) : (
          <div id="content-Central">
            {paginaAtual === "Agendamentos" ? (
              <Agendamentos />
            ) : paginaAtual === "Exaustor" ? (
              <Exaustor />
            ) : paginaAtual === "Chatbot" ? (
              <ChatBot />
            ) : paginaAtual === "history" ? (
              <Eventos
                filtro={filtro}
                eventos={eventos}
                loading={loadingEventos}
                atualizarLista={carregarEventos}
                chamados={chamados}
              />
            ) : paginaAtual === "PLUS" ? (
              <PLUS />
            ) : paginaAtual === "Dispositivos" ? (
              <Dispositivos />
            ) : paginaAtual === "Alarme" ? (
              /* ---------- agora passamos os dados já prontos ---------- */
              <AlarmeModal
                caixas={caixas}
                bombas={bombas}
                status={alarmStatus}
              />
            ) : paginaAtual === "Subsolo" ? (
              <Subsolo />
            ) : (
              <>
                {imagemCentral && <CampoImagem imagem={imagemCentral} loadingImage={loadingImage} />}
                {renderGroup()}
              </>
            )}
          </div>
        )}
      </div>

      <Notificacao
        trocarPagina={trocarPagina}
        setFiltro={setFiltro}
        eventos={eventos}
      />
    </div>
  );
};

export default Main;
